import React from 'react';

import useUrlPrefix from '@app/hooks/useUrlPrefix';
import { EVENTS, trackEvent } from '@app/segment';
import { useTranslation } from 'react-i18next';

/**
 * Currently, the News site does not support a ES-US language prefix, so
 * we redirect to the ES-MX news site. If / when a US-Spanish language
 * news site is launched / supported, this can be removed.
 */
const News = () => {
  const { t } = useTranslation();
  const urlPrefix = useUrlPrefix();

  const newsUrl =
    urlPrefix === '/es-us/'
      ? `https://stockx.com/news/es-mx`
      : `https://stockx.com/news${urlPrefix}`;

  return (
    <li key="News" data-testid="nav-menu-news">
      <a
        href={newsUrl}
        onClick={() => {
          trackEvent(EVENTS.NAVIGATION_ITEM_CLICKED, {
            label: t('News'),
          });
        }}
      >
        {t('News')}
      </a>
    </li>
  );
};

export default News;
